import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import Protection from "../../services/protection.service";
import ProtectionChannelSpamCalls from "./protection-channel-spam-calls.component";
import ProtectionChannelSpamSMS from "./protection-channel-spam-sms.component";
import Translations from "../../services/translation.service";
import Storage from "../../services/storage.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import Helpers from "../../helpers/shared.helper";
import SelectCheckIcon from "../../assets/img/SelectCheck.svg";
import SelectDownArrowIcon from "../../assets/img/SelectDropDownBlank.svg";
// This Component is responsible to let user report based on SMS/Call

// Custom components for react-select
const IconOption = (props) => (
  <components.Option {...props}>
    {props.isSelected ? (
      <div className="react-select-custom-option">
        {props.data.label}
        <img src={SelectCheckIcon} alt="" />
      </div>
    ) : (
      <div className="react-select-custom-option">
        {props.data.label}
      </div>
    )}
  </components.Option>
);

const MenuContainer = (props) => (
  <components.Menu {...props}>
    <div className="react-select-custom-option-container">
      {props.children}
    </div>
  </components.Menu>
);

const DropdownIndicator = () => {
  return <img src={SelectDownArrowIcon} alt="" />;
};

export default function ProtectionChannelForm({
  setStepDetails = () => {},
  setActiveScreen = () => {},
  setStatus = () => {},
  reporterForm = "",
}) {
  let prefix = "scr_protection_channel";
  const [reportType, setReportType] = useState({
    text: Translations.keys[prefix + "_choose_type_of_spam"],
    value: "Select",
  });
  const [reportTypeList, setReportTypeList] = useState([]);
  const [reportSubType, setReportSubType] = useState({
    text: Translations.keys[prefix + "_please_select_an_option"],
    value: "Select",
  });

  const reportSubTypeList =
    reportTypeList.filter(
      (item) => String(item?.ID) === String(reportType?.value)
    )[0]?.LookupSubItems || [];
  
  const reportSubTypeGenericTypeIsSenderName = reportSubType?.FraudGenericType === "SenderName";

  const [loading, setLoading] = useState(false);
  const [pendingSubTypePrefill, setPendingSubTypePrefill] = useState(null);

  const renderReportForm = () => {
    let content = null;

    const reportFormProps = {
      subTypeHasLandlineSubstring: doesSubTypeHaveLandlineSubstring(),
      reportSpamCall,
      reportSubType,
    };

    // Create a unique key that changes when reportSubType changes to force re-mount
    const componentKey = `${reportType?.value}-${reportSubType?.value}`;

    switch (String(reportType?.value)) {
      // case "Fraud_Spam_SMS":
      case "2":
      case "4":
        content = <ProtectionChannelSpamCalls key={componentKey} {...reportFormProps} />;
        break;
      // case "Spam_Calls":
      case "1":
      case "3":
        content = <ProtectionChannelSpamSMS key={componentKey} {...reportFormProps} />;
        break;
      default:
        break;
    }
    return content;
  };

  useEffect(() => {
    getFraudTypeId();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //use effect needed to reset reportSubType when reportType changes
  useEffect(() => {
    if (reportType?.value !== "Select") {
      setReportSubType({
        text: Translations.keys[prefix + "_please_select_an_option"],
        value: "Select",
      });
    }
    // eslint-disable-next-line no-unused-vars
  }, [reportType, prefix]);

  // useEffect to handle SubType prefilling after reportSubTypeList is populated
  useEffect(() => {
    if (pendingSubTypePrefill && reportSubTypeList.length > 0) {
      // Validate that the pending SubTypeID actually exists in the current reportSubTypeList
      const subTypeExists = reportSubTypeList.some(
        (item) => String(item?.ID) === String(pendingSubTypePrefill)
      );
      
      if (subTypeExists) {
        let subTypeData = {
          text: "",
          value: pendingSubTypePrefill,
        };
        getSelectedSubFraud(subTypeData);
      }
      // Always clear the pending prefill
      setPendingSubTypePrefill(null);
    }
  }, [reportSubTypeList, pendingSubTypePrefill]); // eslint-disable-line react-hooks/exhaustive-deps


  const prefilledData = () => {
    let data_payload = JSON.parse(Storage.get("PrePayload"));
     if (data_payload && data_payload?.FraudRequestTypeID) {
      let data = {
        text: "",
        value: data_payload.FraudRequestTypeID,
      };
      getSelectedFraud(data);
      
      // Store SubTypeID for later prefilling after reportType is set
      if (data_payload?.SubTypeID && data_payload.SubTypeID !== "Select") {
        setPendingSubTypePrefill(data_payload.SubTypeID);
      }
    }
  };

  const getFraudTypeId = () => {
    setLoading(true);
    Protection.getFraudTypeId()
      .then((response) => {
        setLoading(false);
        if (response?.data?.length) {
          response.data.forEach((ele) => {
            if (ele?.LookupID === "fraudTypes") {
              if (ele?.LookupItems?.length) {
                setReportTypeList(ele.LookupItems);
                prefilledData();
              }
            }
          });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const reportSpamCall = (formValid, formValue) => {
    Storage.clear("PrePayload");
    setPendingSubTypePrefill(null); // Clear any pending prefill
    setLoading(true);
    Storage.clear("reportErrorStatus");
    if (formValid) {
      let payloads = {
        ReportedMSISDN: formValue?.number
          ? normalizePhoneNumber(formValue?.number) : reportSubTypeGenericTypeIsSenderName ? "GK" :
          "",
        ReportingMSISDN: reporterForm?.number
          ? toInternational(reporterForm?.number)
          : "",
        UserName: formValue?.senderName ? formValue?.senderName : "",
        FraudRequestTypeID: reportType?.value,
        Notes: formValue?.senderMessage ? formValue?.senderMessage : "",
        OTP: reporterForm?.otp,
        SubTypeID: reportSubType?.value,
      };

      let predata = {
        ReportedMSISDN: formValue?.number
          ? normalizePhoneNumber(formValue?.number)
          : "",
        ReportingMSISDN: reporterForm?.number
          ? toInternational(reporterForm?.number)
          : "",
        UserName: formValue?.senderName ? formValue?.senderName : "",
        FraudRequestTypeID: reportType?.value,
        Notes: formValue?.senderMessage ? formValue?.senderMessage : "",
        OTP: reporterForm?.otp,
        SubTypeID: reportSubType?.value,
        ReportedMSISDNNo: formValue?.ReportedMSISDNNo,
        iso_value: formValue?.iso_value,
        iso_code: formValue?.iso_code,
      };
      Storage.set("reportErrorStatus", true, true);
      Protection.reportSpamCall(payloads)
        .then((response) => {
          if (response && response?.data) {
            Storage.clear("PrePayload");
            Storage.set("OperatorTCN", response?.data?.OperatorTCN, true);
            setLoading(false);
            setStepDetails((prevState) => ({
              ...prevState,
              step2: { status: "isDone" },
              step3: { status: "isSuccess" },
            }));
            setStatus("success");
            setActiveScreen("StatusScreen");
          } else {
            setLoading(false);
            setStepDetails((prevState) => ({
              ...prevState,
              step2: { status: "isDone" },
              step3: { status: "isFailure" },
            }));
            setStatus("failure");
            Storage.set("PrePayload", JSON.stringify(predata));
            setActiveScreen("StatusScreen");
          }
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          setLoading(false);
          setStepDetails((prevState) => ({
            ...prevState,
            step2: { status: "isDone" },
            step3: { status: "isFailure" },
          }));
          setStatus("failure");
          setActiveScreen("StatusScreen");
          Storage.clear("reportErrorStatus");
          Storage.set("PrePayload", JSON.stringify(predata));
          window.scrollTo(0, 0);
        });
    } else {
      setLoading(false);
    }
  };

  const getSelectedFraud = (data) => {
    if (data && data?.value !== "Select") {
      setReportType({
        text: Translations.keys[
          prefix + Helpers.processLokaliseKey(String(data?.value))
        ],
        value: data?.value,
      });
    } else {
      setReportType({
        text: Translations.keys[prefix + "_please_select_an_option"],
        value: "Select",
      });
    }
  };

  const getSelectedSubFraud = (data) => {
    if (data && data?.value !== "Select") {
      const selectedItemData = reportSubTypeList.find(
        (item) => String(item?.ID) === String(data?.value)
      );
      setReportSubType({
        text: Translations.keys[
          prefix + Helpers.processLokaliseKey(selectedItemData?.NameEN)
        ],
        value: selectedItemData?.ID,
        NameEN: selectedItemData?.NameEN,
        FraudGenericType: selectedItemData?.FraudGenericType,
      });
    } else {
      setReportSubType({
        text: Translations.keys[prefix + "_choose_type_of_spam"],
        value: "Select",
      });
    }
  };

  const getActiveReportSubType = () => {
    if (reportSubType?.value === "Select") return {};
    return (
      reportSubTypeList.find(
        (item) => String(item?.ID) === String(reportSubType?.value)
      ) || {}
    );
  };

  const doesSubTypeHaveLandlineSubstring = () => {
    const activeReportSubType = getActiveReportSubType();
    return activeReportSubType?.NameEN?.toLowerCase().includes("landline");
  };

  function normalizePhoneNumber(msisdn) {
    msisdn = msisdn.toString();

    if (!msisdn.startsWith("966")) return msisdn;

    let normalized = msisdn.startsWith("9660")
      ? "966" + msisdn.slice(4)
      : msisdn;

    // Ensure it's 12 digits long and starts with '9665'
    if (/^9665\d{8}$/.test(normalized)) {
      return normalized;
    }

    return msisdn;
  }

  function toInternational(msisdn) {
    let number = msisdn.toString();
    if (number.startsWith("0")) {
      number = number.substring(1);
    }
    return "966" + number;
  }

  // Create options array once to avoid duplication
  const reportTypeOptions = [
    { value: "Select", label: Translations.keys[prefix + "_choose_type_of_spam"] },
    ...(reportTypeList?.length
      ? reportTypeList.map((ele) => ({
          value: ele?.ID,
          label: Translations.keys[
            `scr_protection_channel_${Helpers.processLokaliseKey(
              ele?.NameEN,
              true
            )}`
          ]
        }))
      : [])
  ];

  const reportSubTypeOptions = [
    { value: "Select", label: Translations.keys[prefix + "_please_select_an_option"] },
    ...(reportSubTypeList?.length
      ? reportSubTypeList.map((ele) => ({
          value: ele?.ID,
          label: Translations.keys[
            `scr_protection_channel_${Helpers.processLokaliseKey(
              ele?.NameEN,
              true
            )}`
          ]
        }))
      : [])
  ];


  return (
    <div className="protection-form-container">
      {loading ? (
        <SpinnerTimeLoader />
      ) : (
        <>
          <div className="field-section">
            <div className="field-container">
              <label>
                {Translations.keys[prefix + "_choose_report_type"]}    
              </label>
              <Select
                unstyled
                className="react-select-custom"
                name="reportType"
                isSearchable={false}
                options={reportTypeOptions}
                onChange={(selectedOption) => {
                  Storage.clear("PrePayload");
                  setPendingSubTypePrefill(null); // Clear any pending prefill when user manually changes reportType
                  getSelectedFraud(selectedOption || { value: "Select" });
                }}
                components={{ Option: IconOption, Menu: MenuContainer, DropdownIndicator: DropdownIndicator }}
                value={reportTypeOptions.find(option => option.value === reportType?.value)}
                isClearable={false}
              />
              {reportType && reportType?.value !== "Select" && (
                <div className="field-section">
                  <div className="field-container">
                    <label>
                      {Translations.keys[prefix + "_choose_spam_report_type"]}
                    </label>
                    <Select
                      unstyled
                      className="react-select-custom"
                      name="reportSubType"
                      isSearchable={false}
                      options={reportSubTypeOptions}
                      onChange={(selectedOption) => {
                        setPendingSubTypePrefill(null); // Clear any pending prefill when user manually changes reportSubType
                        Storage.clear("PrePayload"); // Clear PrePayload to reset form components
                        getSelectedSubFraud(selectedOption || { value: "Select" });
                      }}
                      components={{ Option: IconOption, Menu: MenuContainer, DropdownIndicator: DropdownIndicator }}
                      value={reportSubTypeOptions.find(option => option.value === reportSubType?.value)}
                      isClearable={false}
                    />
                  </div>
                </div>
              )}
            </div>
            {reportSubType?.value && reportSubType?.value !== "Select" && (
              <>
                <div>
                  <b className="protection-form-title">
                    {
                      Translations.keys[
                        prefix + "_please_provide_the_below_details"
                      ]
                    }
                  </b>
                </div>
                {renderReportForm()}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
